import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, renderSlot as _renderSlot, isRef as _isRef, createSlots as _createSlots, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex-fill position-relative" }
const _hoisted_2 = {
  class: "flex-fill position-relative",
  style: {"padding-top":"5em"}
}
const _hoisted_3 = { class: "pre-line" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = {
  key: 0,
  class: "unreaded-state-list"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "unreaded-state-badge-wrapper" }

import {
    computed,
    getCurrentInstance,
    nextTick,
    onActivated,
    onBeforeUnmount,
    onMounted,
    ref,
    watch
} from 'vue';
import InfiniteScrollContainer from "~/core-ui/vue/InfiniteScrollContainer.vue";
import {
    OPERATOR_APPLICATION_LOAD_DELAYED_MESSAGES_EVENT,
    OPERATOR_APPLICATION_RELOAD_DATA_EVENT
} from "~/operatorApplication/ts/service/comet/Constants";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import Dictionary from "~/ts/library/Dictionary";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import OperatorApplicationMessageStatus from "~/operatorApplication/ts/service/dialog/OperatorApplicationMessageStatus";
import CoreUiChatHistory from "~/core-ui/vue/chat/CoreUiChatHistory.vue";
import {
    getTranslateMessageEventId,
    MESSAGE_REMOVED,
    OperatorApplicationEventManager,
    READ_ALL_MESSAGES_OF_CLIENT,
    SCROLL_CHAT_TO_BOTTOM
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import WindowHelper from "~/ts/library/WindowHelper";
import Delay from "~/ts/library/Delay";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import OperatorApplicationHtmlify from "~/operatorApplication/vue/misc/OperatorApplicationHtmlify.vue";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import Typing from "~/operatorApplication/ts/service/comet/listeners/Typing";
import OperatorTyping from "~/operatorApplication/ts/service/comet/listeners/OperatorTyping";
import ClientClickOnLink from "~/operatorApplication/ts/service/comet/listeners/ClientClickOnLink";
import {__} from "~/ts/library/Translate";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import {toggleArrayElement} from "~/ts/library/ToggleArrayElement";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import useActivated from "~/ts/vuePlugins/useActivated";
import ElConfirm from "~/core-ui/vue/ui/ElConfirm";
import OperatorApplicationDialogHistoryExposeInterface
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogHistoryExposeInterface";
import CoreUiChatHistoryExposeInterface from "~/core-ui/vue/chat/CoreUiChatHistoryExposeInterface";
import OperatorApplicationPlatformFactory from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import CoreUiChatHistoryHelper from "~/core-ui/vue/chat/CoreUiChatHistoryHelper";
import CoreUiChatHistoryMessageDownloadPayloadInterface
    from "~/core-ui/vue/chat/CoreUiChatHistoryMessageDownloadPayloadInterface";
import {
    OPERATOR_ELECTRON_IPC_COPY_MESSAGE_ACTION, OPERATOR_ELECTRON_IPC_COPY_SELECTED_MESSAGES_ACTION
} from "~/operatorApplication/electron/src/ipc/ElectronIpcActionsConstant";
import toggleMessagePin from "~/operatorApplication/ts/service/dialog/toggleMessagePin";
import MyDialog from "~/cabinet/vue/interface/dialog/MyDialog.vue";
import AttachmentsConfig from "~/cabinet/vue/interface/AttachmentsConfig.vue";
import OperatorApplicationUploadHelper from "~/operatorApplication/ts/request/OperatorApplicationUploadHelper";
import {AttachmentsConfigModelInterface} from "~/cabinet/vue/interface/AttachmentsConfigInterface";
import {
    DialogActionInterface,
    MessagesActionInterface,
    TranscribeActionInteface
} from "~/core-ui/vue/chat/CoreUiChatHistoryActions";
import {CopilotCommandRunner} from "~/operatorApplication/ts/service/copilot/CopilotCommandRunner";
import {ElNotification} from "element-plus";
import OpenApiResult from "~/ts/library/openApi/OpenApiResult";
import CopyToClipboardButton from "~/cabinet/vue/interface/CopyToClipboardButton.vue";
import OperatorApplicationIframeSender, {
    CLIENT_DIALOG_OPEN_CASCADE_MESSAGE_REPORT, ClientDialogOpenCascadeMessageReportActionPayloadInterface
} from "~/operatorApplication/ts/OperatorApplicationIframeSender";
import CrossTabMessage from "~/ts/library/crossTabCommunication/talk/CrossTabMessage";
import CoreUiChatHistoryMessageButton from "~/core-ui/vue/chat/CoreUiChatHistoryMessageButton.vue";
import {
    AUDIO_MESSAGE_EVENT,
    AudioMessageEventPayloadInterface
} from "~/operatorApplication/vue/dialogs/dialog/DialogChatAreaExposeInterface";
import Random from "~/ts/library/Random";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import isElementVisibleInScrollContainer from "~/ts/library/dom/isElementVisibleInScrollContainer";
import {
    OPEN_ADD_TEMPLATE_DIALOG_EVENT
} from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/MessageTemplateButtonInterface";
import {MESSAGE_COLOR_OPERATOR_DARK} from "~/operatorApplication/vue/dialogs/dialog/Constants";

import CopilotTranslateMessageResponsePatchItemOpenApiModel = CometOperatorApplication.CopilotTranslateMessageResponsePatchItemOpenApiModel;
import OperatorApplicationMessageOpenApiModel = OperatorApplicationApi.OperatorApplicationMessageOpenApiModel;
import OperatorCopilotTranslateMessagesOpenApiModel = OperatorApplicationApi.OperatorCopilotTranslateMessagesOpenApiModel;
import OperatorCopilotCommandOpenApiModel = OperatorApplicationApi.OperatorCopilotCommandOpenApiModel;
import MessageReactionForSiteOpenApiModel = OperatorApplicationApi.MessageReactionForSiteOpenApiModel;
import OperatorApplicationMessageSuggestedAnswerOpenApiModel = OperatorApplicationApi.OperatorApplicationMessageSuggestedAnswerOpenApiModel;

import OperatorSetSuggestedAnswerRateOpenApiModel = OperatorApplicationApi.OperatorSetSuggestedAnswerRateOpenApiModel;


const __default__ = {
    name: "OperatorApplicationDialogHistory"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {},
    cobrowseEnabled: { type: Boolean },
    selectedMessages: { default: () => [] },
    markAsReadedEnabled: { type: Boolean, default: true },
    shortMessageMargin: { type: Boolean },
    disableBackground: { type: Boolean }
  },
  emits: ["update:selected-messages", "edit-message", "reply-message", "remove-message", "scroll-to-message"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const LIMIT = 30;

let props = __props;

let chatScrollContainer = ref<HTMLDivElement>();

let openCascadeMessageReport = OperatorAccountStore.isCabinetIframe ? (cascadeMessageId: number) => {
    let p: ClientDialogOpenCascadeMessageReportActionPayloadInterface = {
        cascadeMessageId
    };
    try {
        OperatorApplicationIframeSender.send(
            new CrossTabMessage(CLIENT_DIALOG_OPEN_CASCADE_MESSAGE_REPORT, p)
        );
    } catch (e) {

    }
} : null;

let emits = __emit;

let history = ref<CoreUiChatHistoryExposeInterface>();

let messages = ref<OperatorApplicationApi.OperatorApplicationMessageOpenApiModel[]>();
let delayedMessages = ref<OperatorApplicationApi.OperatorApplicationMessageOpenApiModel[]>();
let notifications = ref<OperatorApplicationApi.OperatorApplicationMessageOpenApiModel[]>();
let clientTyping = ref<string>();
let operatorTypingValue = ref<Dictionary<string>>({}); //{}
let isLoading = ref(false);
let isMounted = ref(false);
let isScrolledToBottom = ref(true);
let needToFetchOnActivate = ref(false);
let scrollingOnMessageHeightChange = false;


let username = computed(() => {
    return props.userdata.username;
});

let isActivated = useActivated();

let instance = getCurrentInstance().proxy;

messages.value = ClientUserdataStore.getMessagesByUsername(username.value);
addDisposableEvent(
    OperatorApplicationEventManager.addEventListener(MESSAGE_REMOVED, (messageId: number) => {
        let message = delayedMessages.value?.find(item => item.id == messageId);
        if (message) {
            toggleArrayElement(delayedMessages.value, message, false);
        }
    })
);
addDisposableEvent(
    OperatorApplicationEventManager.addEventListener(OPERATOR_APPLICATION_RELOAD_DATA_EVENT, async () => {
        if (!OperatorAccountStore.isCabinetIframe) {
            if (isActivated.value) {
                reloadMessages();
            } else {
                needToFetchOnActivate.value = true;
            }
        }
    })
);
addDisposableEvent(
    OperatorApplicationEventManager.addEventListener(OPERATOR_APPLICATION_LOAD_DELAYED_MESSAGES_EVENT, (username: string) => {
        if (username === props.userdata.username) {
            loadDelayedMessages();
        }
    })
);
addDisposableEvent(
    OperatorApplicationEventManager.addEventListener(SCROLL_CHAT_TO_BOTTOM, async eventUsername => {
        if (eventUsername == username.value && isScrolledToBottom.value) {
            await Delay.make(300);
            scrollToBottom();
        }
    })
);
addDisposableEvent(
    OperatorApplicationEventManager.addEventListener(
        Typing.getEventNameByUsername(username.value),
        (text: string) => {
            clientTyping.value = text;
        }
    )
);

addDisposableEvent(
    OperatorApplicationEventManager.addEventListener(
        OperatorTyping.getEventNameByUsername(username.value),
        (payload: CometOperatorApplication.OperatorTypingCometMessageOpenApiModel) => {
            if (typeof payload.text == "string") {
                operatorTypingValue.value[payload.operator] = payload.text;
            } else {
                delete operatorTypingValue.value[payload.operator];
            }
        }
    )
);

addDisposableEvent(
    OperatorApplicationEventManager.addEventListener(
        ClientClickOnLink.getEventNameByUsername(username.value),
        (link: string) => {
            if (history.value) {
                let links = history.value.$el.querySelectorAll(`a[href="${link}"]`);
                for (let i = 0; i < links.length; i++) {
                    let a = links[i];
                    let nextElement = a.nextElementSibling;
                    if (!nextElement || !nextElement.classList.contains("link-opened")) {
                        let sup = document.createElement("sup");
                        sup.innerText = __("открыл");
                        sup.className = "link-opened ml-1 mr-1";
                        a.parentNode.insertBefore(sup, a.nextSibling);
                    }
                }
            }
        }
    )
);

addDisposableEvent(
    OperatorApplicationEventManager.addEventListener(
        READ_ALL_MESSAGES_OF_CLIENT, eventUsername => {
            if (eventUsername == username.value) {
                readMessages();
            }
        }
    )
)


onActivated(() => {
    scrollToBottom(0);
    if (needToFetchOnActivate.value) {
        needToFetchOnActivate.value = false;
        reloadMessages();
    }
});

async function reloadMessages() {
    messages.value.splice(0, messages.value.length);
    messages.value.push(...(await fetchMessages()));
    instance.$nextTick(async () => {
        scrollToBottom(0);
        await Delay.make(100);
        scrollToBottom(0);
        await Delay.make(100);
        scrollToBottom(0);
    });
}

let applicationPlatform = computed(() => {
    return OperatorApplicationPlatform;
});

let showOperatorLogins = computed(() => {
    return OperatorAccountStore.data.value.accessRights.canViewOperatorsLogin;
});

let isTranslateEnabled = computed(() => ClientUserdataStore.isTranslateEnabled(props.userdata.username) && !!props.userdata.languageIsoCode);

watch(isTranslateEnabled, value => {
    if (value) {
        let lastMessages = messages.value.filter(message => !message.messageType && !message.translatePatch).slice(-6);
        if (lastMessages.length > 0) {
            let maxId = Math.max(...lastMessages.map(message => message.id));
            if (maxId > lastTranslatedMessageId.value) {
                lastTranslatedMessageId.value = maxId;
            }
            CoreUiChatHistoryHelper.translateMessages(translateMessages, lastMessages);

        }
    }
});

let lastTranslatedMessageId = ref(0);

let newMessagesForTranslate = computed(() => {
    if (isTranslateEnabled.value) {
        return messages.value.filter(message => (
            !lastTranslatedMessageId.value || message.id > lastTranslatedMessageId.value
        ) && !message.messageType && !message.translatePatch).slice(-6);
    } else {
        return [];
    }
});

watch(newMessagesForTranslate, () => {
    translateNewMessages();
});

function translateNewMessages() {
    let messages = newMessagesForTranslate.value;
    if (messages.length > 0) {
        CoreUiChatHistoryHelper.translateMessages(translateMessages, messages);
    }
}

let messagesCount = computed(() => messages.value.length);
watch(messagesCount, () => {
    if (isTranslateEnabled.value) {
        translateNewMessages();
    }
});

translateNewMessages();


function scrollToBottom(duration: number = 100) {
    WindowHelper.scrollToBottom(chatScrollContainer.value, duration);
}

let customOperatorStatusDictionary = OperatorAccountStore.customStatusDictionary;
let messageSourceTypeDictionary = OperatorAccountStore.messageSourceTypeDictionary;

async function onMessageHeightChange() {
    if (isScrolledToBottom.value) {
        try {
            scrollingOnMessageHeightChange = true;
            await Delay.make(200, "dialogHistoryScroll", true);
            if (isScrolledToBottom.value) {
                scrollToBottom();
            }
            scrollingOnMessageHeightChange = false;
        } catch (e) {

        }
    }
}

function onTextareaKeyUp() {
    if (isScrolledToBottom.value) {
        scrollToBottom(0);
    }
}

let you = OperatorAccountStore.operator;


onMounted(() => {
    isMounted.value = true;
    readMessages();
    nextTick(() => {
        scrollToBottom(0);
    });
});

onBeforeUnmount(() => {

    if (messages.value.length > LIMIT) {
        messages.value.splice(0, messages.value.length - LIMIT);
    }
});

let htmlify = computed(() => {
    return OperatorApplicationHtmlify;
});

let operators = computed(() => {
    return OperatorAccountStore.data.value.operators;
});

let firstRealMessageId = computed(() => {
    return messages.value
        ?.find(message => !message.messageType || !message.messageType.isAutoMessage)
        ?.id;
});

let messageIds = computed(() => {
    let result: Dictionary<any> = {};
    for (let message of messages.value) {
        result[message.id] = true;
    }
    return result;
});

async function fetchMessages(lastMessageId?: number, silent: boolean = true) {

    let p: OperatorApplicationApi.OperatorMessageGetOpenApiModel = {
        username: username.value,
        count: LIMIT,
        lastMessageId
    };
    if (firstRealMessageId.value) {
        p.firstMessageId = firstRealMessageId.value;
    }
    isLoading.value = true;
    let messages: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel[] = [];

    if (OperatorAccountStore.isAuthorized.value) {
        let error = false;
        try {
            let result = await (new OperatorApiRequest<OperatorApplicationApi.OperatorMessageGetResultOpenApiModel>({
                url: "/message/get",
                p,
                silent: silent,
                silentError: silent
            })).send();

            if (result.isSuccess) {
                let data = result.data;
                messages = data.messages.filter(message => !messageIds.value[message.id]);

                /*
                for (let i = messages.length - 1; i >= 0; i--) {
                    if (messages[i].isSendByClient) {
                        OperatorApplicationMessageStatus.setMessageStatusReaded(props.userdata, messages[i]);
                        break;
                    }
                }
                */
            } else {
                error = true;
            }
        } catch (e) {
            error = true;
        }
        if (error) {
            reloadMessagesAfterError();
        }
    }

    isLoading.value = false;
    return messages;
}


async function reloadMessagesAfterError() {
    try {
        await Delay.make(3000, `reloadMessagesAfterError_${username.value}`, true);
    } catch (e) {
        return;
    }
    if (isActivated.value) {
        reloadMessages();
    } else {
        needToFetchOnActivate.value = true;
    }
}


let lastUnreadedMessage = computed(() => {
    for (let i = messages.value.length - 1; i >= 0; i--) {
        let message = messages.value[i];
        //let isSendByClient = this.isMessageSendByClient(message);

        if (message.isSendByClient) {
            if (message.statusId == "readed") {
                break;
            }
            return message;
        }
    }
    return null;
});

let firstUnreadedMessage = computed(() => {
    let result: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel;
    for (let i = messages.value.length - 1; i >= 0; i--) {
        let message = messages.value[i];
        //let isSendByClient = this.isMessageSendByClient(message);

        if (message.isSendByClient) {
            if (message.statusId == "readed") {
                break;
            } else {
                result = message;
            }
        }
    }
    return result;
});

function readMessages() {
    if (lastUnreadedMessage.value && props.userdata && props.markAsReadedEnabled) {
        OperatorApplicationMessageStatus.setMessageStatusReaded(props.userdata, lastUnreadedMessage.value);
    }
}

watch(computed(() => props.markAsReadedEnabled), newValue => {
    if (newValue) {
        readMessages();
    }
});


function clearSelectedMessages() {
    history.value.clearSelectedMessages();
}

async function markMessageStateAsViewed(messageIds: number[]) {
    if (messageIds.length && props.markAsReadedEnabled) {
        for (let id of messageIds) {
            for (let item of props.userdata.messagesWithUnreadedState) {
                if (item.messageId == id) {
                    toggleArrayElement(props.userdata.messagesWithUnreadedState, item, false);
                }
            }
        }
        let p: OperatorApplicationApi.OperatorMarkMessageStateAsViewedOpenApiModel = {
            messageIds,
            username: props.userdata.username
        };
        (new OperatorApiRequest({
            url: `/message/markMessageStateAsViewed`,
            p,
            silent: true,
            silentError: true
        })).send();
    }
}

async function onScroll() {
    if (!scrollingOnMessageHeightChange) {
        //scrollTop.value = instance.$el.scrollTop;
        history.value?.onScroll(chatScrollContainer.value.scrollTop);
    }
    let appWindow = OperatorApplicationPlatformFactory.window;
    if (props.markAsReadedEnabled && props.userdata.messagesWithUnreadedState.length && (appWindow.isFocused() || !appWindow.isFocusAvailable())) {
        try {
            await Delay.make(100, 'trackMessagesWithUnreadedState');
            let messageIds: number[] = [];
            for (let item of props.userdata.messagesWithUnreadedState) {
                let messageId = item.messageId;
                let element = chatScrollContainer.value.querySelector(`.chat-history-message-${messageId}`);
                if (element) {
                    if (isElementVisibleInScrollContainer(element as HTMLElement, chatScrollContainer.value)) {
                        toggleArrayElement(props.userdata.messagesWithUnreadedState, item, false);
                        toggleArrayElement(messageIds, messageId, true);
                    }
                }
            }
            if (messageIds.length) {
                markMessageStateAsViewed(messageIds);
            }
        } catch (e) {

        }
    }


}

async function scrollToMessageWithState(id: number) {
    markMessageStateAsViewed([id]);
    scrollToMessage(id);
}

async function editMessage(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel): Promise<OperatorApplicationApi.OperatorApplicationMessageOpenApiModel> {
    emits("edit-message", message);
    return message;
}

async function pin(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel) {
    toggleMessagePin(message.username, message.id, !message.isPinned);
}

async function copy(message?: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel) {
    if (message) {
        OperatorApplicationEventManager.emit(
            OPERATOR_ELECTRON_IPC_COPY_MESSAGE_ACTION,
            message.id
        );
    } else {
        OperatorApplicationEventManager.emit(
            OPERATOR_ELECTRON_IPC_COPY_SELECTED_MESSAGES_ACTION
        );
    }
}

let sendMessageToRatesDialog = ref<{
    visible: boolean,
    message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel,
    model: {
        text: string,
        rateValue: string,
        attachments: AttachmentsConfigModelInterface[]
    }
}>();

async function sendRate() {
    let model = sendMessageToRatesDialog.value.model;
    let p: OperatorApplicationApi.OperatorMessageSendRateOpenApiModel = {
        username: props.userdata.username,
        rateValueId: model.rateValue,
        text: model.text,
        messageId: sendMessageToRatesDialog.value.message.id,
        attachments: model.attachments
    };
    let result = (await (new OperatorApiRequest({
        url: "/message/sendRate",
        p
    })).send());
    result.showMessage();
    if (result.isSuccess) {
        sendMessageToRatesDialog.value = null;
    }
}

async function sendToRates(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel) {
    sendMessageToRatesDialog.value = {
        visible: true,
        message,
        model: {
            text: message.content.text,
            rateValue: site.value.rateValues[0].id,
            attachments: message.content.attachments?.map(attachment => ({
                size: attachment.fileSize,
                url: attachment.url,
                filename: attachment.fileName
            })) ?? []
        }
    };
}

let rateUploadHelper = computed(() => {
    return (new OperatorApplicationUploadHelper())
        .setTag("operatorApplicationRate");
});

async function replyMessage(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel) {
    emits("reply-message", message);
}

async function addToTemplates(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel) {
    OperatorApplicationEventManager.emit(OPEN_ADD_TEMPLATE_DIALOG_EVENT, message);
}

let downloadMessageAttachments = computed(() => {
    return OperatorApplicationPlatformFactory.isDownloadAvailable ? (
        payload: CoreUiChatHistoryMessageDownloadPayloadInterface
    ) => {
        let urls: string[] = [];
        if (payload.attachment) {
            urls.push(payload.attachment.url);
        } else if (payload.message) {
            urls.push(...CoreUiChatHistoryHelper.getUrlListForDownload(payload.message, payload.snippetUrls));
        }
        OperatorApplicationPlatformFactory.download(urls);
    } : null;
});

async function removeMessage(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel): Promise<boolean> {
    emits("remove-message", message);
    return false;
}

let operatorMessageBackground = computed(() => {
    return OperatorApplicationConfigInstance.darkThemeEnabled ? MESSAGE_COLOR_OPERATOR_DARK : OperatorApplicationConfigInstance.operatorMessageBackground;
});

let clientMessageBackground = computed(() => {
    return OperatorApplicationConfigInstance.darkThemeEnabled ? 'client-dark' : undefined;
});

function getContactsByMessage(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel): OperatorApplicationApi.OperatorApplicationMessageContactOpenApiModel[] {
    return message.contacts.filter(contact => {
        return props.userdata.fields[contact.fieldName] !== contact.value;
    });
}

async function applyContact(contact: OperatorApplicationApi.OperatorApplicationMessageContactOpenApiModel) {
    let p: OperatorApplicationApi.OperatorBuddyListUpdateClientInfoOpenApiModel = {
        username: props.userdata.username,
        fields: {
            [contact.fieldName]: contact.value
        }
    };
    (await (new OperatorApiRequest({
        url: "/buddyList/updateClientInfo",
        p
    })).send()).showMessageOnError();
}

let canEditClientInfo = computed(() => {
    return OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.canEditClientInfo, props.userdata.siteId);
});

let canSendRate = computed(() => {
    return props.userdata.type.isReal && OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.canSendRate, props.userdata.siteId);
});

let site = computed(() => OperatorAccountStore.sitesDictionary.value[props.userdata.siteId]);

function getFieldDescrByName(fieldName: string) {
    if (site.value) {
        let field = site.value.userFields.find(item => item.name == fieldName);
        if (field) {
            return field.descr;
        }
    }
    return fieldName;
}

async function loadDelayedMessages() {
    let p: OperatorApplicationApi.OperatorMessageGetOpenApiModel = {
        username: username.value,
        delayed: true
    };
    if (OperatorAccountStore.isAuthorized.value) {
        try {
            let result = await (new OperatorApiRequest<any>({
                url: "/message/get",
                p,
                silentError: true
            })).send();

            if (!result.showMessageOnError()) {
                delayedMessages.value = result.data.messages;
                nextTick(() => {
                    scrollToBottom();
                });
            }
        } catch (e) {
        }
    }
}

async function loadNotifications() {
    let p: OperatorApplicationApi.OperatorGetNotificationsOpenApiModel = {
        username: username.value
    };
    if (OperatorAccountStore.isAuthorized.value) {
        try {
            let result = await (new OperatorApiRequest<any>({
                url: "/message/getNotifications",
                p,
                silentError: true
            })).send();

            if (!result.showMessageOnError()) {
                notifications.value = result.data.notifications;
                nextTick(() => {
                    scrollToBottom();
                });
            }
        } catch (e) {
        }
    }
}

async function removeNotification(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel) {
    let p: OperatorApplicationApi.OperatorRemoveNotificationOpenApiModel = {
        username: username.value,
        id: message.id
    }
    if (OperatorAccountStore.isAuthorized.value) {
        try {
            await ElConfirm(__("Вы уверены, что хотите удалить это напоминание?"));
            let result = await (new OperatorApiRequest({
                url: "/message/removeNotification",
                p
            })).send();

            if (!result.showMessageOnError()) {
                notifications.value = notifications.value.filter(item => item.id != message.id);
            }
            return result.isSuccess;
        } catch (e) {
        }
    }
    return false;
}

async function scrollToMessage(id: number) {
    emits("scroll-to-message", id);
}

function translateMessages(messages: OperatorApplicationMessageOpenApiModel[]): Dictionary<Promise<CopilotTranslateMessageResponsePatchItemOpenApiModel[]>> {
    let result: Dictionary<Promise<CopilotTranslateMessageResponsePatchItemOpenApiModel[]>> = {};
    for (let message of messages) {
        (function (message: OperatorApplicationMessageOpenApiModel) {
            result[message.id] = new Promise<CopilotTranslateMessageResponsePatchItemOpenApiModel[]>((resolve, reject) => {
                OperatorApplicationEventManager.once(getTranslateMessageEventId(message.id), (patch: CopilotTranslateMessageResponsePatchItemOpenApiModel[]) => {
                    resolve(patch);
                }, 30000, () => reject());
            });
        })(message);
    }
    let p: OperatorCopilotTranslateMessagesOpenApiModel = {
        username: props.userdata.username,
        messageIdList: messages.map(message => message.id),
        languageIsoCode: OperatorAccountStore.data.value.settings.languageIsoCode
    };
    (new OperatorApiRequest({
        url: "/copilot/translateMessages",
        p,
        silent: true,
        silentError: true
    })).send();
    return result;
}

async function setSuggestRate(suggest: OperatorApplicationMessageSuggestedAnswerOpenApiModel, value: boolean): Promise<OpenApiResult<any>> {
    let p: OperatorSetSuggestedAnswerRateOpenApiModel = {
        username: props.userdata.username,
        id: suggest.id,
        value
    };
    return await (new OperatorApiRequest({
        url: "/message/setSuggestedAnswerRate",
        p,
        silent: true,
        silentError: true
    })).send();
}

let copilotTextCommandResultDialog = ref<{
    visible: boolean,
    commandDescr: string,
    result: string
}>();

async function runMessageCommand(command: OperatorCopilotCommandOpenApiModel, commandDescr: string) {
    let notification = ElNotification({
        showClose: true,
        title: __(`AI Copilot`),
        message: `${__("Выполняется команда")}:<br />${commandDescr}`,
        dangerouslyUseHTMLString: true,
        //iconClass: $iconLight('sparkles'),
        //TODO: что делать с iconClass?
        duration: 0
    });
    let result = await CopilotCommandRunner.exec({
        username: props.userdata.username,
        command,
        timeout: 60,
        onResult: value => {
            notification.close();
            copilotTextCommandResultDialog.value = {
                visible: true,
                commandDescr,
                result: value
            }
        },
        onTimeout: () => {
            notification.close();
            OpenApiResult.showMessage(__("Не удалось выполнить команду. Попробуйте ещё раз."), "error");
        }
    });
    if (result.showMessageOnError()) {
        notification.close();
    }
}

let otherMessagesActions = computed(() => {
    let result: MessagesActionInterface[] = [];
    if (site.value) {
        for (let command of site.value.copilotCommands) {
            if (command.isMessageCommand) {
                (function (command) {
                    result.push({
                        descr: command.descr,
                        icon: command.icon,
                        callback: (messages: OperatorApplicationMessageOpenApiModel[], text?: string) => {
                            runMessageCommand({
                                type: command.id as any,
                                params: {
                                    text,
                                    messageIds: text ? undefined : messages.map(message => message.id)
                                }
                            }, command.descr);
                        }
                    })
                })(command);

            }
        }
    }
    return result;
});

let otherDialogActions = computed(() => {
    let result: DialogActionInterface[] = [];
    if (site.value) {
        for (let command of site.value.copilotCommands) {
            if (command.isMessageCommand) {
                (function (command) {
                    result.push({
                        descr: command.descr,
                        icon: command.icon,
                        callback: dialogIds => {
                            runMessageCommand({
                                type: command.id as any,
                                params: {
                                    dialogIds
                                }
                            }, command.descr);
                        }
                    })
                })(command);

            }
        }
    }
    return result;
});

async function setMessageReaction(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel, emoji?: string): Promise<boolean> {
    let p: OperatorApplicationApi.OperatorMessageSetMessageReactionOpenApiModel = {
        messageId: message.id,
        emoji
    };
    let requestResult = await (new OperatorApiRequest<OperatorApplicationApi.OperatorGetDialogStatisticResultOpenApiModel>({
        url: "/message/setMessageReaction",
        p,
        silent: true
    })).send();
    return !requestResult.showMessageOnError();
}

async function getDialogStatistic(dialogId: number) {
    let p: OperatorApplicationApi.OperatorGetDialogStatisticOpenApiModel = {
        dialogId,
        username: props.userdata.username
    };
    let requestResult = await (new OperatorApiRequest<OperatorApplicationApi.OperatorGetDialogStatisticResultOpenApiModel>({
        url: "/message/getDialogStatistic",
        p
    })).send();
    if (!requestResult.showMessageOnError()) {
        return requestResult.data;
    }
    return null;
}

async function questionCategoryChange(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel, value?: string) {
    let result = false;
    if (message.dialog.id) {
        let p: OperatorApplicationApi.OperatorMessageSetQuestionCategoryOpenApiModel = {
            username: props.userdata.username,
            dialogId: message.dialog.id,
            questionCategory: value
        }
        let requestResult = await (new OperatorApiRequest({
            url: "/message/setQuestionCategory",
            p
        })).send();
        requestResult.showMessageOnError();
        result = requestResult.isSuccess;
    }
    return result;
}

async function dialogTagsChange(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel, tags: string[]) {
    let result = false;
    if (message.dialog.id) {
        let p: OperatorApplicationApi.OperatorMessageSetDialogTagsOpenApiModel = {
            username: props.userdata.username,
            dialogId: message.dialog.id,
            tags
        }
        let requestResult = await (new OperatorApiRequest({
            url: "/message/setDialogTags",
            p
        })).send();
        requestResult.showMessageOnError();
        result = requestResult.isSuccess;
    }
    return result;
}

async function messageTagsChange(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel, tags: string[]) {
    let result = false;
    if (message.dialog.id) {
        let p: OperatorApplicationApi.OperatorMessageSetMessageTagsOpenApiModel = {
            username: props.userdata.username,
            messageId: message.id,
            tags
        }
        let requestResult = await (new OperatorApiRequest({
            url: "/message/setMessageTags",
            p
        })).send();
        requestResult.showMessageOnError();
        result = requestResult.isSuccess;
    }
    return result;
}

async function loadMessagesByLastMessageId(id: number) {
    if (!messages.value.find(item => item.id == id)) {
        let firstMessageId = firstRealMessageId.value;
        if (!isLoading.value && firstMessageId) {
            if (firstMessageId > id) {
                let newMessages = await fetchMessages(id, false);
                messages.value.splice(0, 0, ...newMessages);
            }
            return;
        }
        await Delay.make(300);
        await loadMessagesByLastMessageId(id);
    }
}

let hasBackgroundImage = computed(() => {
    return !!OperatorApplicationConfigInstance.historyBackground && !OperatorApplicationConfigInstance.darkThemeEnabled && !props.disableBackground;
});

let messageReactions = computed<MessageReactionForSiteOpenApiModel[]>(() => {
    if (CoreUiChatHistoryHelper.isOneOfCrossOperatorsChat(props.userdata)) {
        return OperatorAccountStore.data.value.messageReactions;
    }
    let result: MessageReactionForSiteOpenApiModel[] = [];
    if (site.value) {
        result = site.value.messageReactions;
        let integration = props.userdata.integration;
        if (integration && result.length > 0) {
            let platformId = integration.platformId;
            let authPrimaryId = integration.authPrimaryId;
            let auth = site.value.integrations.find(auth => auth.authPrimaryId == authPrimaryId && platformId == auth.platformId);
            result = auth?.messengerPlatformData?.messageReactions ?? [];
        }
    }
    return result;
});

function m(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel) {
    return message;
}

function getAudioEventPayload(audio: HTMLAudioElement, play: boolean): AudioMessageEventPayloadInterface {
    return {
        audio,
        play,
        client: props.userdata,
        key: Random.uid()
    }
}

function onAudioPlay(audio: HTMLAudioElement) {
    OperatorApplicationEventManager.emit(AUDIO_MESSAGE_EVENT, getAudioEventPayload(audio, true));
}

function onAudioEnded(audio: HTMLAudioElement) {
    OperatorApplicationEventManager.emit(AUDIO_MESSAGE_EVENT, getAudioEventPayload(audio, false));
}

let transcribeAction: TranscribeActionInteface = {
    getLanguages: () => OperatorAccountStore.data.value.languages,
    addTask: async (messageId: number, languageId: string) => {
        let p: OperatorApplicationApi.OperatorTranscribeMessageFileOpenApiModel = {
            messageId,
            languageId
        };

        let result = await (new OperatorApiRequest({
            url: `/message/transcribeMessage`,
            p
        })).send();
        result.showMessageOnError();
    }
};

let unreadedStateList = computed(() => ClientUserdataStore.getUnreadedStateListByUserdata(props.userdata));

__expose<OperatorApplicationDialogHistoryExposeInterface>({
    readMessages,
    clearSelectedMessages,
    onTextareaKeyUp,
    scrollToBottom,
    scrollToMessageById: async (id: number) => {
        await loadMessagesByLastMessageId(id);
        isScrolledToBottom.value = false;
        history.value.scrollToMessageById(id);
    },
    showMessageNavigator: payload => {
        history.value.showMessageNavigator(payload);
    }
});


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "absolute-full-size chat-scroll-container d-flex flex-column",
      style: _normalizeStyle({
                fontSize: `${_unref(OperatorApplicationConfigInstance).chatHistoryScale}em`
            }),
      onScrollPassive: onScroll,
      ref_key: "chatScrollContainer",
      ref: chatScrollContainer
    }, [
      (_unref(isLoading))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass({'loader': true, 'small': !!_unref(messages).length})
          }, [
            _createElementVNode("div", null, [
              _createVNode(MyLoader, { big: "" })
            ])
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (_unref(isMounted))
          ? (_openBlock(), _createBlock(InfiniteScrollContainer, {
              key: 0,
              "load-method": fetchMessages,
              "scroll-container": _unref(chatScrollContainer),
              items: _unref(messages),
              onScrolledToBottom: _cache[4] || (_cache[4] = ($event: any) => (_isRef(isScrolledToBottom) //@ts-ignore
 ? isScrolledToBottom.value = $event : isScrolledToBottom = $event))
            }, {
              default: _withCtx(({loading}) => [
                _createVNode(CoreUiChatHistory, {
                  ref_key: "history",
                  ref: history,
                  operators: _unref(operators),
                  "virtual-operators": _unref(site)?.virtualOperators,
                  messages: _unref(messages),
                  you: _unref(you),
                  client: __props.userdata,
                  "show-seconds": _unref(OperatorApplicationConfigInstance).showSecondsInChat,
                  "operator-message-background": _unref(operatorMessageBackground),
                  "client-message-background": _unref(clientMessageBackground),
                  "selected-messages": __props.selectedMessages,
                  "show-dialog-info": _unref(OperatorApplicationConfigInstance).showDialogsInChat,
                  "show-operator-group": _unref(site)?.isShowOperatorGroupInChat ?? false,
                  "has-background-image": _unref(hasBackgroundImage),
                  "show-answered-not-in-time-messages": _unref(OperatorApplicationConfigInstance).showAnsweredNotInTimeMessages,
                  "hide-system-messages": !_unref(OperatorApplicationConfigInstance).showSystemMessagesInChat,
                  "message-actions": {
                                edit: editMessage,
                                pin: pin,
                                copy: copy,
                                remove: removeMessage,
                                reply: replyMessage,
                                download: _unref(downloadMessageAttachments),
                                removeNotification: removeNotification,
                                questionCategoryChange: questionCategoryChange,
                                getDialogStatistic: getDialogStatistic,
                                sendToRates: _unref(canSendRate) ? sendToRates : undefined,
                                addToTemplates: addToTemplates,
                                dialogTagsChange: dialogTagsChange,
                                messageTagsChange: messageTagsChange,
                                fetchMessagesFromId: async id => await loadMessagesByLastMessageId(id),
                                scrollToMessage: scrollToMessage,
                                translateMessages: translateMessages,
                                otherMessagesActions: _unref(otherMessagesActions),
                                otherDialogActions: _unref(otherDialogActions),
                                setMessageReaction: setMessageReaction,
                                openCascadeMessageReport: _unref(openCascadeMessageReport),
                                onAudioPlay: onAudioPlay,
                                onAudioEnded: onAudioEnded,
                                transcribe: _unref(transcribeAction),
                                setSuggestRate: setSuggestRate
                            },
                  "is-translate-enabled": _unref(isTranslateEnabled),
                  "scroll-container": _unref(chatScrollContainer),
                  htmlify: _unref(htmlify),
                  "short-message-margin": __props.cobrowseEnabled || __props.shortMessageMargin,
                  "operator-application-platform": _unref(applicationPlatform),
                  "client-typing": _unref(clientTyping),
                  "operator-typing": _unref(operatorTypingValue),
                  "show-operator-logins": _unref(showOperatorLogins),
                  "custom-operator-status-dictionary": _unref(customOperatorStatusDictionary),
                  "message-source-type-dictionary": _unref(messageSourceTypeDictionary),
                  "delayed-messages": _unref(delayedMessages),
                  "onUpdate:delayedMessages": _cache[0] || (_cache[0] = ($event: any) => (_isRef(delayedMessages) ? (delayedMessages).value = $event : delayedMessages = $event)),
                  notifications: _unref(notifications),
                  "onUpdate:notifications": _cache[1] || (_cache[1] = ($event: any) => (_isRef(notifications) ? (notifications).value = $event : notifications = $event)),
                  "site-question-categories": _unref(site) && !_unref(site).isFree ? _unref(site).questionCategoriesTree : [],
                  "dialog-tags": _unref(site) && !_unref(site).isFree ? _unref(site).dialogTags : [],
                  "message-tags": _unref(site) && !_unref(site).isFree ? _unref(site).messageTags : [],
                  "message-reactions": _unref(messageReactions),
                  "sticky-always": _unref(OperatorApplicationConfigInstance).stickyDialogInfoEnabledAlways,
                  "sticky-allowed": _unref(OperatorApplicationConfigInstance).stickyDialogInfoEnabled,
                  "sticky-timeout": _unref(OperatorApplicationConfigInstance).stickyDialogInfoTimeout,
                  "onUpdate:selectedMessages": _cache[2] || (_cache[2] = ($event: any) => (_unref(emits)('update:selected-messages', $event))),
                  onMessageHeightChange: onMessageHeightChange,
                  "load-delayed-messages-listening": "",
                  "first-unreaded-message-id-for-notification": !__props.markAsReadedEnabled ? _unref(firstUnreadedMessage)?.id : undefined,
                  onLoadDelayedMessages: loadDelayedMessages,
                  "load-notifications-listening": "",
                  "show-suggested-answers": "",
                  "show-suggested-answers-buttons": !_unref(OperatorAccountStore).isCabinetIframe,
                  onLoadNotifications: loadNotifications,
                  onHasDelayedMessagesChanged: _cache[3] || (_cache[3] = ($event: any) => (scrollToBottom(0)))
                }, _createSlots({ _: 2 }, [
                  (_unref(canEditClientInfo))
                    ? {
                        name: "message-meta-start",
                        fn: _withCtx(({message}) => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getContactsByMessage(message), (contact, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: i,
                              class: "mt-2"
                            }, [
                              _withDirectives((_openBlock(), _createBlock(CoreUiChatHistoryMessageButton, {
                                class: "w-100 d-block text-truncate",
                                round: "",
                                icon: "save",
                                "is-client": m(message).isSendByClient,
                                onClick: ($event: any) => (applyContact(contact))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(__)("Сохранить %1$s как %2$s", contact.value, getFieldDescrByName(contact.fieldName))), 1)
                                ]),
                                _: 2
                              }, 1032, ["is-client", "onClick"])), [
                                [
                                  _directive_on_native,
                                  void 0,
                                  "click",
                                  { stop: true }
                                ]
                              ])
                            ]))
                          }), 128))
                        ]),
                        key: "0"
                      }
                    : undefined,
                  (_unref(messages).length > 0)
                    ? {
                        name: "after",
                        fn: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "after-messages")
                        ]),
                        key: "1"
                      }
                    : undefined
                ]), 1032, ["operators", "virtual-operators", "messages", "you", "client", "show-seconds", "operator-message-background", "client-message-background", "selected-messages", "show-dialog-info", "show-operator-group", "has-background-image", "show-answered-not-in-time-messages", "hide-system-messages", "message-actions", "is-translate-enabled", "scroll-container", "htmlify", "short-message-margin", "operator-application-platform", "client-typing", "operator-typing", "show-operator-logins", "custom-operator-status-dictionary", "message-source-type-dictionary", "delayed-messages", "notifications", "site-question-categories", "dialog-tags", "message-tags", "message-reactions", "sticky-always", "sticky-allowed", "sticky-timeout", "first-unreaded-message-id-for-notification", "show-suggested-answers-buttons"])
              ]),
              _: 3
            }, 8, ["scroll-container", "items"]))
          : _createCommentVNode("", true),
        (_unref(sendMessageToRatesDialog) && _unref(sendMessageToRatesDialog).visible)
          ? (_openBlock(), _createBlock(MyDialog, {
              key: 1,
              visible: _unref(sendMessageToRatesDialog).visible,
              "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_unref(sendMessageToRatesDialog).visible) = $event)),
              title: _unref(__)('Отправить в отзывы'),
              onApply: sendRate
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(__)('Оценка')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(sendMessageToRatesDialog).model.rateValue,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(sendMessageToRatesDialog).model.rateValue) = $event)),
                          class: "w-100"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(site).rateValues, (rateValue) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: rateValue.id,
                                value: rateValue.id,
                                label: rateValue.descr
                              }, null, 8, ["value", "label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      label: _unref(__)('Текст')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(sendMessageToRatesDialog).model.text,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(sendMessageToRatesDialog).model.text) = $event)),
                          type: "textarea",
                          autosize: {
                                minRows: 3,
                                maxRows: 10
                            }
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_card, { class: "transparent-dashed-card" }, {
                          default: _withCtx(() => [
                            _createVNode(AttachmentsConfig, {
                              modelValue: _unref(sendMessageToRatesDialog).model.attachments,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(sendMessageToRatesDialog).model.attachments) = $event)),
                              "upload-helper": _unref(rateUploadHelper)
                            }, null, 8, ["modelValue", "upload-helper"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["visible", "title"]))
          : _createCommentVNode("", true),
        (_unref(copilotTextCommandResultDialog) && _unref(copilotTextCommandResultDialog).visible)
          ? (_openBlock(), _createBlock(_component_el_dialog, {
              key: 2,
              modelValue: _unref(copilotTextCommandResultDialog).visible,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(copilotTextCommandResultDialog).visible) = $event)),
              title: `AI Copilot: ${_unref(copilotTextCommandResultDialog).commandDescr}`
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(copilotTextCommandResultDialog).result), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(CopyToClipboardButton, {
                    content: _unref(copilotTextCommandResultDialog).result
                  }, null, 8, ["content"])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "title"]))
          : _createCommentVNode("", true)
      ])
    ], 36),
    (_unref(unreadedStateList).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(unreadedStateList), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "unreaded-state",
              onClick: ($event: any) => (scrollToMessageWithState(Math.max(...item.messageIds)))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_tag, {
                  class: "unreaded-state-badge",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.messageIds.length), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createVNode(FontAwesomeIcon, {
                icon: item.icon,
                class: "icon",
                light: ""
              }, null, 8, ["icon"])
            ], 8, _hoisted_6))
          }), 256))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})